export const stickerTypeProperty = 'stickerType'
export const stickerIconProperty = 'stickerIcon'
export const stickerReadonlyProperty = 'stickerReadonly'
export const stickerDeadlineAsStatisticsDatesProperty =
  'stickerDeadlineAsStatisticsDates'
export const stickerDeadlineNoClearFilterProperty =
  'stickerDeadlineNoClearFilter'

export type StickerIcon =
  | ''
  | 'star'
  | 'heart'
  | 'check'
  | 'cloud'
  | 'filter'
  | 'alarm'
  | 'bolt'
  | 'bookmark'
  | 'box'
  | 'bulb'
  | 'prio'
  | 'code'
  | 'ruble'
  | 'dollar'
  | 'euro'
  | 'eye'
  | 'flag'
  | 'flame'
  | 'history'
  | 'info'
  | 'key'
  | 'anchor'
  | 'message'
  | 'movie'
  | 'mnote'
  | 'pencil'
  | 'picture'
  | 'pin'
  | 'clockwise'
  | 'clockwiseDot'
  | 'rectangle'
  | 'shield'
  | 'stack'
  | 'string'
  | 'timeStop'
  | 'design'
  | 'user'
  | 'plus'
  | 'gear'
  | 'sort'
  | 'calendar'

export const stickerIcons: StickerIcon[] = [
  '', // no icon specified
  'star',
  'heart',
  'check',
  'cloud',
  'filter',
  'alarm',
  'bolt',
  'bookmark',
  'box',
  'bulb',
  'prio',
  'code',
  'ruble',
  'dollar',
  'euro',
  'eye',
  'flag',
  'flame',
  'history',
  'info',
  'key',
  'anchor',
  'message',
  'movie',
  'mnote',
  'pencil',
  'picture',
  'pin',
  'clockwise',
  'clockwiseDot',
  'rectangle',
  'shield',
  'stack',
  'string',
  'timeStop',
  'design',
  'user',
  'plus',
  'gear',
  'sort',
  'calendar'
]

export const stickerColors = [
  'sticker-white',
  'sticker-gray',
  'sticker-red',
  'sticker-pink',
  'sticker-orange',
  'sticker-green',
  'sticker-turquoise',
  'sticker-blue',
  'sticker-violet',
  'sticker-transparent'
] as const

export type StickerColor = (typeof stickerColors)[number] | 'sticker-panel'

export const systemStickerTypes = [
  'deadline',
  'repeat',
  'stopwatch',
  'timer',
  'timetracking',
  'user'
] as const

export const customStickerTypes = [
  'string',
  'sprint',
  'text',
  'numeric'
] as const

export const stickerTypes = [
  ...systemStickerTypes,
  ...customStickerTypes
] as const

export type SystemStickerType = (typeof systemStickerTypes)[number]
export type CustomStickerType = (typeof customStickerTypes)[number]
export type StickerType = (typeof stickerTypes)[number]

export const stickersWithFilters: StickerType[] = [
  'deadline',
  'user',
  'string',
  'sprint'
]

export const systemStickerIconsMap = {
  deadline: 'IconCustomCalendar',
  repeat: 'clockwise',
  stopwatch: 'timeStop',
  timer: 'history',
  timetracking: 'clockwiseDot',
  user: 'user'
} as const

export const stickerTypesWithoutSettings: StickerType[] = [
  'repeat',
  'timer',
  'timetracking'
]
